import { ApiClient } from '@/shared/api/client';
import { CredentialTransport } from '@/features/external-account/transport';
import type { ExternalAccount, ExternalCredential, SealedReply } from '@/features/external-account/types';

/**
 * 계정 보관함(외부·내부 인프라 공용) — 아이디·비밀번호는 항상 `CredentialTransport`로 잠근 채 오간다.
 *
 * 서버 공개키는 호출마다 받는다. 화면에 묶어 두면 서버 키를 바꾼 뒤 열려 있던 화면이 옛 키로 잠가
 * 계속 실패한다.
 */
export const createAccountVaultApi = (basePath: string) => {
  const api = {
  transportKey: async () => (await ApiClient.getJson<{ publicKey: string }>(`${basePath}/transport-key`)).publicKey,
  list: () => ApiClient.getJson<{ accounts: ExternalAccount[] }>(basePath),
  create: async (service: string, link: string, credential: ExternalCredential) =>
    ApiClient.postJson<ExternalAccount>(basePath, {
      service,
      link,
      credential: await CredentialTransport.seal(await api.transportKey(), credential),
    }),
  update: async (id: number, service: string, link: string, credential: ExternalCredential) =>
    ApiClient.patchJson<ExternalAccount>(`${basePath}/${id}`, {
      service,
      link,
      credential: await CredentialTransport.seal(await api.transportKey(), credential),
    }),
  reveal: async (id: number) =>
    CredentialTransport.receive(
      (ephemeralKey) => ApiClient.postJson<SealedReply>(`${basePath}/${id}/reveal`, { ephemeralKey }),
      await api.transportKey(),
    ),
  remove: (id: number) => ApiClient.deleteJson<{ removed: true }>(`${basePath}/${id}`),
};
  return api;
};

export const externalAccountApi = createAccountVaultApi('/external-accounts');
export const internalInfraAccountApi = createAccountVaultApi('/internal-infra-accounts');
